var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4282 1.11235L10.4286 1.11198C10.5583 0.982247 10.7667 0.982247 10.8964 1.11198C11.0178 1.23339 11.0178 1.45014 10.8964 1.57154L6.82144 5.64654L6.46789 6.0001L6.82144 6.35365L10.8964 10.4287C11.0262 10.5584 11.0262 10.7668 10.8964 10.8965C10.7667 11.0263 10.5583 11.0263 10.4286 10.8965L6.35355 6.82154L6 6.46799L5.64645 6.82154L1.57145 10.8965C1.44171 11.0263 1.23329 11.0263 1.10355 10.8965C0.973814 10.7668 0.973814 10.5584 1.10355 10.4287L5.17855 6.35365L5.53211 6.0001L5.17855 5.64654L1.10355 1.57154C0.973814 1.44181 0.973814 1.23339 1.10355 1.10365C1.23329 0.973913 1.44171 0.973913 1.57145 1.10365L5.64645 5.17865L5.99964 5.53184L6.35319 5.17901L10.4282 1.11235Z",
    fill: "#2B8C34",
    stroke: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.543eae8e88e657e53f9dbded0dd10405.svg";
export { ForwardRef as ReactComponent };